import React, { useEffect } from "react";
import PropTypes from "prop-types";
import RecommendArticleBox from "../common/RecommendArticleBox";

function PCRecommendArticlesBox({ heading, articles = [], idx, type }) {
  const wrapperId = `gtmRecommend${type}-${idx}`;

  useEffect(() => {
    const event = new CustomEvent("gtm_ecommerce_item_list_rendering", {
      detail: {
        wrapperSelector: `#${wrapperId}`,
        userType: "person",
      },
    });
    window.dispatchEvent(event);
  }, [wrapperId]);

  return (
    <div className="m_recommendBox">
      <h4 className="p_insertionHeading">{heading}</h4>
      <div
        className="jsSlideArrow slideArrow isLeft isDisable"
        data-idx={idx}
        data-direction="left"
      />
      <ul
        className={`recommendUl jsRecommend${idx}`}
        id={wrapperId}
        data-idx={idx}
      >
        {articles.map((article) => (
          <RecommendArticleBox key={article.id} article={article} />
        ))}
      </ul>
      <div
        className="jsSlideArrow slideArrow isRight"
        data-idx={idx}
        data-direction="right"
      />
    </div>
  );
}

PCRecommendArticlesBox.propTypes = {
  heading: PropTypes.string.isRequired,
  articles: PropTypes.arrayOf(PropTypes.object),
  idx: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
};

PCRecommendArticlesBox.defaultProps = {
  articles: [],
};

export default PCRecommendArticlesBox;
